'use client'

import { Sidebar, useUI } from 'app/_components/ui'

export function CartSidebarSkeleton() {
  const { displaySidebar, closeSidebar } = useUI()

  return (
    <Sidebar open={displaySidebar} onClose={closeSidebar}>
      <div className={'w-full md:w-[500px] max-w-[500px] relative h-full z-0'}>
        <div className="h-[75px] bg-black-20 animate-pulse rounded-lg" />
        <div className="flex flex-col items-center gap-4 p-16">
          <p className="mb-4 text-3xl text-center text-black-20 font-regular">
            Fetching cart data...
          </p>
          <div className="bg-black-20 rounded-full w-112 h-20 animate-pulse" />
        </div>
      </div>
    </Sidebar>
  )
}
